export const GET_ANALOGS_LIST = 'GET_ANALOGS_LIST';
export const DELETE_REVIEW = 'DELETE_REVIEW';
export const SUBMIT_REVIEW = 'SUBMIT_REVIEW';
